__turbopack_context__.v({
  "logo": "XUzUNq_logo",
});
